import * as React from 'react';
import { PricePanel } from 'components/DateFormPanel/PricePanel';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ReduxState } from 'ducks';
import { toProductShape, Price } from 'lib/util/productShape';

export const DateFormThirdPartyBookingLink = () => {
  const { t } = useTranslation();

  const product = useSelector((state: ReduxState) => state.server.product.product);

  const productShape = product && toProductShape(product);
  const prices: Price[] =
    productShape?.priceSchedules?.find((priceSchedule) => priceSchedule.prices != null)?.prices ??
    [];

  if (!product) return null;
  if (
    !product?.booking_widget_settings?.is_visible ||
    product?.booking_widget_settings?.is_view_only ||
    product.third_party_booking_settings?.third_party_booking_type !== 'BOOKING_LINK'
  ) {
    return (
      <div className="widget-calendar__main">
        <p style={{ color: 'red' }}>{t('Sorry, this product is currently not available.')}</p>
      </div>
    );
  }

  return (
    <>
      <PricePanel prices={prices} />
      <div className="widget-calendar__main">
        <a
          href={product.third_party_booking_settings?.booking_link_url}
          target="_blank"
          rel="noopener noreferrer"
          className="widget-calendar__button"
          style={{ marginBottom: '8px' }}
        >
          {t('Book Now')}
        </a>
      </div>
    </>
  );
};
